// layouts/dashboard/components/OrderOverview/index.jsx
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import TimelineItem from "examples/Timeline/TimelineItem";

export default function OrdersOverview({ top = [], onItemClick }) {
  const items = top.length ? top : Array.from({ length: 6 }, () => ({ title: "—", value: 0 }));

  return (
    <Card className="h-100">
      <SoftBox pt={3} px={3}>
        <SoftTypography variant="h6" fontWeight="medium">
          Top por Streams
        </SoftTypography>
        <SoftBox mt={1} mb={2}>
          <SoftTypography variant="button" color="text" fontWeight="regular">
            <SoftTypography display="inline" variant="body2" verticalAlign="middle">
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
      </SoftBox>

      <SoftBox p={2}>
        {items.map((it, i) => {
          const handleClick = () => {
            if (!onItemClick) return;
            onItemClick(it);
          };

          const clickable = Boolean(onItemClick && it);

          return (
            <SoftBox
              key={i}
              onClick={clickable ? handleClick : undefined}
              sx={{
                cursor: clickable ? "pointer" : "default",
                borderRadius: "10px",
                p: 1,
                "&:hover": {
                  backgroundColor: clickable ? "rgba(0, 0, 0, 0.04)" : "transparent",
                },
              }}
            >
              <TimelineItem
                color={["success", "error", "info", "warning", "primary", "dark"][i % 6]}
                icon="music_note"
                title={it.title}
                dateTime={String(it.value)}
              />
            </SoftBox>
          );
        })}
      </SoftBox>
    </Card>
  );
}
